import { render, staticRenderFns } from "./JalekoResponde.vue?vue&type=template&id=bfc0cdfa&scoped=true&"
import script from "./JalekoResponde.vue?vue&type=script&lang=js&"
export * from "./JalekoResponde.vue?vue&type=script&lang=js&"
import style0 from "./JalekoResponde.vue?vue&type=style&index=0&id=bfc0cdfa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc0cdfa",
  null
  
)

export default component.exports